import { render, staticRenderFns } from "./IncidentItem.vue?vue&type=template&id=753b97ad&scoped=true"
import script from "./IncidentItem.vue?vue&type=script&lang=js"
export * from "./IncidentItem.vue?vue&type=script&lang=js"
import style0 from "./IncidentItem.vue?vue&type=style&index=0&id=753b97ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b97ad",
  null
  
)

export default component.exports